import {
    useCreateTestDefinitionMutation,
    useDeleteTestDefinitionMutation,
    useTestDefinitionQuery,
    useUpdateTestDefinitionMutation,
} from './useTestDefinitionsQuery';
import {TestDefinitionFormValues} from '../types';

export const useTestDefinition = (testDefinitionId?: string) => {
    const {
        data: record,
        isLoading: loading,
        refetch: fetchRecord
    } = useTestDefinitionQuery(testDefinitionId || '');

    const createMutation = useCreateTestDefinitionMutation();
    const updateMutation = useUpdateTestDefinitionMutation();
    const deleteMutation = useDeleteTestDefinitionMutation();

    const createRecord = async (values: TestDefinitionFormValues) => {
        return await createMutation.mutateAsync(values);
    };

    const updateRecord = async (values: TestDefinitionFormValues) => {
        if (typeof testDefinitionId === 'undefined') {
            throw new Error('testDefinitionId is required parameter');
        }
        return await updateMutation.mutateAsync({
                                                    id: testDefinitionId,
                                                    record: values,
                                                });
    };

    const deleteRecord = async () => {
        if (typeof testDefinitionId === 'undefined') {
            throw new Error('testDefinitionId is required parameter');
        }
        return await deleteMutation.mutateAsync(testDefinitionId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
